module.exports = __webpack_public_path__ + "assets/img/18_920.2431c6ab.jpg";